import { head, prop, propEq, propOr } from 'ramda'
import React, { useContext, useState } from 'react'

import { generateContext } from '@btime/react-contexts'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useTabName = () => prop('name', useTab())
export const useSetTabByName = () => prop('setTabByName', useContext(ActionsContext))
export const useTab = () => propOr({}, 'tab', useContext(StateContext) || {})
export const useTabOptions = () => propOr([], 'tabOptions', useContext(StateContext) || {})
export const useSetTab = () => prop('setTab', useContext(ActionsContext))

export const TabsContext = ({ defaultValue, options, onChangeTab, ...props }) => {
  const [tab, setTab] = useState(defaultValue || head(options))
  const handleSetTab = newTab => {
    if (onChangeTab) onChangeTab(newTab)
    setTab(newTab)
  }
  const setTabByName = name => handleSetTab(options.find(propEq('name', name)))
  return <Provider state={{ tab, tabOptions: options }} actions={{ setTab: handleSetTab, setTabByName }} {...props} />
}
